/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `user` - user
 * * `developer` - developer
 * * `management` - management
 * @export
 */
export const DepTypeEnum = {
  user: 'user',
  developer: 'developer',
  management: 'management',
} as const;
export type DepTypeEnum = (typeof DepTypeEnum)[keyof typeof DepTypeEnum];

export function instanceOfDepTypeEnum(value: any): boolean {
  for (const key in DepTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(DepTypeEnum, key)) {
      if ((DepTypeEnum as Record<string, DepTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DepTypeEnumFromJSON(json: any): DepTypeEnum {
  return DepTypeEnumFromJSONTyped(json, false);
}

export function DepTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DepTypeEnum {
  return json as DepTypeEnum;
}

export function DepTypeEnumToJSON(value?: DepTypeEnum | null): any {
  return value as any;
}
